package com.cybersoftsolution.cybersoftsolutionweb.components.bars

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.icons.MyFaIcon
import com.cybersoftsolution.cybersoftsolutionweb.components.indicators.LoadingIndicator
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.selectedColor
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.unselectedColor
import com.cybersoftsolution.cybersoftsolutionweb.components.textfield.InputTypeHTML
import com.cybersoftsolution.cybersoftsolutionweb.components.textfield.MyTextField
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.styles.Scale_Selected_ItemStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.SearchTextNoStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.SimpleWithAnimationStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.XIconStyle2
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.searchTextFieldId
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onFocusIn
import com.varabyte.kobweb.compose.ui.modifiers.onFocusOut
import com.varabyte.kobweb.compose.ui.modifiers.onKeyDown
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.icons.fa.FaMagnifyingGlass
import com.varabyte.kobweb.silk.components.icons.fa.FaX
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.GeneralKind
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.HTMLInputElement

@Composable
fun SearchBarNoCollapsable(
    id: String,
    modifier: Modifier = Modifier,
    onSearch: (text: String,category: String?) -> Unit,
    searchText :String ="",
    onSearchTextChange: (String) -> Unit,
    style: CssStyle<GeneralKind>,
    isSearching: Boolean = false,
    setSearching: (Boolean) -> Unit = {},

){

    var focused by remember { mutableStateOf(false) }

    Row(
        horizontalArrangement = Arrangement.Start,
        verticalAlignment = Alignment.CenterVertically,
        modifier = style.toModifier()
            .fillMaxWidth()
            .height(45.px)
            .padding(left = 16.px, right = 0.px)
            .backgroundColor(Theme.Transparent.rgb)
            .borderRadius(50.px)
            .thenIf(
                condition = focused,
                other = Modifier.border(
                    width = 2.px,
                    style = LineStyle.Solid,
                    color = selectedColor
                )

            )
            .then(modifier)

        ,
    ) {

        if (isSearching) {
            LoadingIndicator(
                size = 2,
                modifier = Modifier
                    .color(Theme.Primary.rgb)
                    .padding(left = 5.px)
                    .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
                    .width(10.px)
                    .height(10.px)
                    .margin(right = 20.px)
            )
        } else {
            FaMagnifyingGlass(
                size = IconSize.SM,
                modifier = Modifier
                    .color(if (focused) selectedColor else unselectedColor)
                    .margin(right = 14.px)
                    .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
            )
        }





        MyTextField(
            usePlaceholderColorStyle = true,
            modifier = Modifier
                .background(Colors.Transparent)
//                        .weight(1)
                .fillMaxHeight()
//                .fillMaxWidth( if (categories.isEmpty()) 90.percent else 70.percent)
                .fillMaxWidth( 90.percent)
                .padding(left = 5.px , right = 5.px)
                .margin(topBottom = 10.px)
                .fontSize(15.px)
                .color(selectedColor)
                .onFocusIn {
                    focused = true
                    console.info("focused = $focused")
                }
                .onFocusOut {
                    focused = false
                    console.info("focused = $focused")

                }
                .onKeyDown {
                    if (it.key == "Enter") {
                        (document.getElementById(searchTextFieldId) as HTMLInputElement).blur()
                        setSearching(true)
                        onSearch(searchText,  null)
                        setSearching(false)
                    }

                }


            ,
            text = searchText,
            style = SearchTextNoStyle,
            inputTypeHTML = InputTypeHTML.Text,
            id = id,
            placeholder = "Buscar...",
            onChange = {
                onSearchTextChange(it)
            }
        )



        FaX(
            size = IconSize.SM,
            modifier = XIconStyle2.toModifier()
                .visibility(if (searchText.isEmpty()) Visibility.Hidden else Visibility.Visible)
                .margin( leftRight = 10.px)
                .fillMaxWidth(10.percent)
                .onClick {
                    onSearchTextChange("")
                    (document.getElementById(searchTextFieldId) as HTMLInputElement).blur()
                    onSearch("", null )//categorySelected)
                    (document.getElementById(id) as HTMLInputElement).focus()
                }
                .cursor(Cursor.Pointer)
                .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))

        )



    }







}